module.exports = __webpack_public_path__ + "img/emoji_65.7c856d30.png";